import {TrackingDeliveryStatus} from 'types/tracking';
import {getStatusLabel} from '../../useTracking';
import styles from './DeliveryTimeline.module.scss';

type Props = {
  status: TrackingDeliveryStatus;
  stopsBeforeCount: number;
  deliveryAddress: string;
  eta: string;
};

function DeliveryTimeline({
  status,
  stopsBeforeCount,
  deliveryAddress,
  eta,
}: Props) {
  const statusClass = styles[status.replace('_', '')];

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>Delivery Progress</h3>
      <div className={styles.timeline}>
        {stopsBeforeCount > 0 && (
          <div className={styles.timelineItem}>
            <div className={styles.timelineLeft}>
              <div className={`${styles.dot} ${styles.neutral}`}>
                <span>{stopsBeforeCount}</span>
              </div>
              <div className={styles.line} />
            </div>
            <div className={styles.timelineContent}>
              <div className={styles.stopHeader}>
                <span className={styles.stopNumber}>
                  {stopsBeforeCount} {stopsBeforeCount === 1 ? 'stop' : 'stops'}{' '}
                  before yours
                </span>
              </div>
            </div>
          </div>
        )}

        <div className={`${styles.timelineItem} ${styles.current}`}>
          <div className={styles.timelineLeft}>
            <div className={`${styles.dot} ${statusClass}`}>
              {status === 'completed' && (
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path
                    d="M5.25 9.15L2.8 6.7L1.86667 7.63333L5.25 11.0167L12.25 4.01667L11.3167 3.08333L5.25 9.15Z"
                    fill="currentColor"
                  />
                </svg>
              )}
              {status === 'canceled' && (
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path
                    d="M11.0833 2.91667L2.91667 11.0833M2.91667 2.91667L11.0833 11.0833"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              )}
              {status === 'delivering' && <div className={styles.pulsingDot} />}
            </div>
          </div>

          <div className={styles.timelineContent}>
            <div className={styles.stopHeader}>
              <span className={styles.stopNumber}>Your Delivery</span>
              {eta && <span className={styles.time}>{eta}</span>}
            </div>

            <div className={styles.stopDetails}>
              <span className={styles.address}>{deliveryAddress}</span>
            </div>

            <div className={`${styles.statusTag} ${statusClass}`}>
              {getStatusLabel(status)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeliveryTimeline;
